import React, { useContext, useEffect, useRef } from "react";
import styles from "./Building.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import BuildingContext from "../../context/building";
const Building = (props) => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const building = useContext(BuildingContext);
  const refWrap = useRef(null);
  const { updateActiveBuilding } = building;
  const { index, disable } = props;
  const handleClick = (e) => {
    e.stopPropagation();
    if (disable !== undefined && disable) return;
    updateActiveBuilding(index)
  }
  let wrapClass = `${styles.wrap}`;
  let hiddenElement = null;
  if(window.innerWidth > 767){
    if (!disable ) {
      hiddenElement = <div className={styles.hidden}>
      <picture>
        <img src={`${path}/img/buildings/building-${index}-hover.webp`} alt=""  loading="lazy"/>
      </picture>
    </div>;
    }
  
    
    }
  useEffect(()=>{
    const wrap = refWrap.current;
    if(disable){
      wrap.classList.add(styles.disable);
    }else{

      wrap.classList.remove(styles.disable);
    }
  },[disable]);
  useEffect(()=>{
    const wrap = refWrap.current;
    if(isMobile){
      wrap.classList.add(styles.mobile);
    }else{
      wrap.classList.remove(styles.mobile);
    }
  },[isMobile]);
  return (
    <>
      <div className={wrapClass} onClick={handleClick} ref={refWrap}>
        {hiddenElement}
        <div className={styles.bg}>
          <picture>
            <img src={`${path}/img/buildings/building-${index}.webp`} alt="" loading="lazy"/>
          </picture>
        </div>
      </div>
    </>
  );

}

export default Building;
